import { WordingKey } from "@typings/i18n-typings";

export interface Survey {
	id: string;
	link: string;
	title: string;
	popupTitleKey: WordingKey;
	popupBodyKey: WordingKey;
	popupPrimaryCtaKey: WordingKey;
	popupSecondaryCtaKey: WordingKey;
}

export const SURVEY_COMPLETION_POSTMESSAGE = "request-survey-completion";
